var _defs, _circle, _path, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _path2, _path3, _circle11, _path4, _path5, _path6, _path7, _circle12, _path8, _path9, _path10, _path11, _path12, _path13, _circle13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _circle14, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIsItForMe(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 540,
    height: 380.55,
    viewBox: "0 0 540 380.55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#5222ff;}.b{fill:#f2f2f2;}.c{fill:#3f3d56;}.d{fill:#2e394d;}.e{fill:#a0616a;}.f{fill:#2f2e41;}.g{fill:#e6e6e6;}.h{fill:#ffb8b8;}.i{fill:#d3dae5;}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 29.408,
    cy: 29.408,
    r: 29.408,
    transform: "translate(246.381 320.928)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M673.737,547.376c16.452-4.941,33.943-10.093,46.99-21.839,11.659-10.5,19.531-26.524,14.7-42.265-4.82-15.709-19.258-26.183-34.165-31.393A140.166,140.166,0,0,0,675.121,446c-9.612-1.4-19.266-2.547-28.916-3.651q-58.609-6.7-117.659-8.19c-19.425-.489-38.846-.477-58.274-.2-17.35.252-35.623.246-51.719-7.129-12.516-5.734-23.876-16.167-27.364-29.877-4.026-15.826,3.4-31.942,14.052-43.4a113.775,113.775,0,0,1,18.946-15.8c7.344-5.072,14.944-9.785,22.708-14.185a316.221,316.221,0,0,1,47.8-22.036c8.148-2.963,16.417-5.519,24.758-7.877a211.849,211.849,0,0,0,20.915-6.7c13.159-5.245,25.675-14.128,29.021-28.693,3.171-13.8-2.176-28.788-11.549-39.042-10.844-11.863-27.2-17.064-42.871-17.905-17.6-.945-34.792,3.46-51.334,9.05-17.643,5.962-34.9,12.817-52.92,17.647a356.066,356.066,0,0,1-54.466,10.124c-9,.959-18.278,2.041-27.334,1.307-7.59-.615-15.141-2.847-20.735-8.234-4.8-4.619-7.654-10.967-6.671-17.665.178-1.217,2.027-.7,1.849.51-1.2,8.154,4.347,15.668,11.178,19.517,7.894,4.448,17.5,4.455,26.289,3.946a343.837,343.837,0,0,0,56.587-8.18c18.279-4.175,35.905-10.143,53.512-16.519,16.721-6.055,33.817-11.965,51.681-13.276,15.5-1.138,31.806,1.12,45.31,9.221a50.124,50.124,0,0,1,23.376,32.616c2.717,13.313-1.046,26.713-11.124,36C549.733,287,535.426,291.112,522.093,294.9a348.816,348.816,0,0,0-49.477,17.711,310.594,310.594,0,0,0-46.541,26.165c-14.222,9.719-28.258,21.947-32.756,39.286a36.191,36.191,0,0,0,1.8,24.271,44.352,44.352,0,0,0,14.232,16.889c14.27,10.5,32.254,12.656,49.491,12.871,19.359.241,38.718-.412,58.084-.095q59.2.972,118.154,7.207,14.773,1.564,29.509,3.457a266.829,266.829,0,0,1,26.389,4.28c15.447,3.585,30.478,10.479,40.079,23.576a37.281,37.281,0,0,1,3.175,40.766c-7.373,14.506-21.182,23.733-35.848,29.794a254.347,254.347,0,0,1-24.134,8.149.96.96,0,0,1-.51-1.849Z",
    transform: "translate(-222.265 -169.285)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 15.343,
    cy: 15.343,
    r: 15.343,
    transform: "translate(65.14 29.088)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 15.343,
    cy: 15.343,
    r: 15.343,
    transform: "translate(171.583 58.176)"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 15.343,
    cy: 15.343,
    r: 15.343,
    transform: "translate(261.724)"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 15.343,
    cy: 15.343,
    r: 15.343,
    transform: "translate(317.983 65.208)"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 15.343,
    cy: 15.343,
    r: 15.343,
    transform: "translate(241.906 140.646)"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 15.343,
    cy: 15.343,
    r: 15.343,
    transform: "translate(145.372 177.086)"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 15.343,
    cy: 15.343,
    r: 15.343,
    transform: "translate(247.66 233.983)"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 15.343,
    cy: 15.343,
    r: 15.343,
    transform: "translate(357.619 265.948)"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 15.343,
    cy: 15.343,
    r: 15.343,
    transform: "translate(486.118 258.916)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M556.591,220.371A85.1,85.1,0,0,0,472.345,304c-.006.424-.009,3.408-.008,7.31a21.575,21.575,0,0,0,21.571,21.574h0a21.587,21.587,0,0,0,21.583-21.6c0-2.659,0-4.5,0-4.609a40.915,40.915,0,1,1,62.984,34.445l.007.009s-30.7,19.767-40.065,46.883l.008,0a60.1,60.1,0,0,0-2.476,17.113c0,2.382.14,23.22.411,40.134A22.239,22.239,0,0,0,558.6,467.139h0a22.245,22.245,0,0,0,22.244-22.382c-.094-15.49-.145-33.526-.145-34.835,0-16.65,16.063-33.24,29.257-44.059a88.736,88.736,0,0,0,30.518-48.586,55.464,55.464,0,0,0,1.6-12.04,84.867,84.867,0,0,0-85.48-84.865Z",
    transform: "translate(-283.952 -176.897)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M716.9,746.772H178.424a.761.761,0,1,1,0-1.522H716.9a.761.761,0,1,1,0,1.522Z",
    transform: "translate(-177.662 -366.222)"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    className: "d",
    cx: 19.179,
    cy: 19.179,
    r: 19.179,
    transform: "translate(382.588 136.168)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M566.486,565.072h-7.837l-3.729-30.231h11.568Z",
    transform: "translate(-200.16 -192.918)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M546.626,578.626h15.115v9.517H537.109A9.517,9.517,0,0,1,546.626,578.626Z",
    transform: "translate(-193.736 -208.711)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M661.486,565.072h-7.837l-3.729-30.231h11.568Z",
    transform: "translate(-234.427 -192.918)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M641.626,578.626h15.115v9.517H632.109A9.517,9.517,0,0,1,641.626,578.626Z",
    transform: "translate(-228.002 -208.711)"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 15.702,
    cy: 15.702,
    r: 15.702,
    transform: "translate(383.15 143.234)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M784.516,479.493l7.026-16.142a20.063,20.063,0,0,0-4.443-22.759,20.385,20.385,0,0,0-1.963-1.707,19.777,19.777,0,0,0-12.14-4.2,20.573,20.573,0,0,0-8.567,1.905c-.23.1-.454.211-.684.32-.441.211-.876.441-1.3.678a20.252,20.252,0,0,0-10.037,15.266l-3.1,25.981c-.78,2.039-28.6,75.687-18.872,131.913a2.856,2.856,0,0,0,2.442,2.346l9.865,1.342a2.875,2.875,0,0,0,3.2-2.257l16.552-78.9a2.24,2.24,0,0,1,4.347-.147l23.386,82.968a2.859,2.859,0,0,0,2.755,2.1,3.281,3.281,0,0,0,.556-.051l12.051-2.321a2.858,2.858,0,0,0,2.321-3.075C806.144,593.007,796.733,494.089,784.516,479.493Z",
    transform: "translate(-376.305 -254.201)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M706.077,418.172a6.429,6.429,0,0,0,6.773,7.162l8.777,21.092,6.639-9.842-9.353-18.521a6.463,6.463,0,0,0-12.836.108Z",
    transform: "translate(-368.246 -246.168)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M796.087,523.4a6.429,6.429,0,0,0,5.387-8.255l18.466-13.45-11.118-4.163-15.832,13.41a6.464,6.464,0,0,0,3.1,12.458Z",
    transform: "translate(-398.105 -276.87)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M740.3,469.857a10.9,10.9,0,0,1-2.109-.208,10.424,10.424,0,0,1-7.638-6.148l-12.3-14.994a2.877,2.877,0,0,1,.71-4.271l8.748-5.415a2.877,2.877,0,0,1,3.974.953l8.667,14.278,16.6-12.266a6.215,6.215,0,0,1,7.23,9.948l-16.565,15.111A10.39,10.39,0,0,1,740.3,469.857Z",
    transform: "translate(-372.419 -255.537)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M817.24,495.051h-.068a2.882,2.882,0,0,1-2.117-1l-7.778-9.074a2.877,2.877,0,0,1,.588-4.266L822.431,471l-13.194-15.863a6.215,6.215,0,0,1,9.517-7.788l16.036,15.671a10.564,10.564,0,0,1-2.35,17.223l-13.106,13.907A2.882,2.882,0,0,1,817.24,495.051Z",
    transform: "translate(-404.516 -258.182)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M790.406,456.733a2.965,2.965,0,0,1-.373-.024,2.852,2.852,0,0,1-2.372-1.962l-5.845-17.919a1.971,1.971,0,0,1,1.019-2.381l.19-.09c.172-.082.342-.163.516-.24a20.825,20.825,0,0,1,8.7-1.933,20.027,20.027,0,0,1,10.971,3.3,2,2,0,0,1,.576,2.745L792.821,455.4a2.848,2.848,0,0,1-2.415,1.329Z",
    transform: "translate(-395.547 -253.299)"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    className: "d",
    cx: 6.276,
    cy: 6.276,
    r: 6.276,
    transform: "translate(410.612 134.233)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M786.733,361.365h0a16.622,16.622,0,0,0-16.622,16.622v7.032h8.649l4.137-7.032,1.241,7.032h26.249l-7.032-7.032A16.622,16.622,0,0,0,786.733,361.365Z",
    transform: "translate(-391.359 -227.754)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M834.809,361.631a9.685,9.685,0,0,1,10.536-6.646c4,.669,7.162,3.883,9.046,7.474s2.754,7.609,4.021,11.461,3.063,7.725,6.261,10.219,8.1,3.17,11.245.6a12.861,12.861,0,0,1-23.959,4.591c-1.657-2.948-2.085-6.4-2.576-9.75s-1.13-6.808-3.108-9.551-5.682-4.534-8.825-3.285Z",
    transform: "translate(-414.696 -225.421)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M499.83,342.5h0a21.575,21.575,0,0,1-21.573-21.571c0-3.9,0-6.888.008-7.312a84.072,84.072,0,0,1,9.819-38.3,84.262,84.262,0,0,0-16.212,48.528c-.006.424-.009,3.408-.008,7.31a21.575,21.575,0,0,0,21.571,21.574h0a21.591,21.591,0,0,0,20.769-15.721A21.494,21.494,0,0,1,499.83,342.5Z",
    transform: "translate(-283.781 -196.717)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M587.743,285.681a40.918,40.918,0,0,1,35.583,57.162,40.913,40.913,0,1,0-68.677-42.824,40.833,40.833,0,0,1,33.094-14.338Z",
    transform: "translate(-313.642 -196.748)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M600.409,541.182h0A22.24,22.24,0,0,1,578.168,519.3c-.271-16.909-.411-37.747-.411-40.129a60.1,60.1,0,0,1,2.476-17.113l-.008,0a60.772,60.772,0,0,1,3.512-8.12,70.356,70.356,0,0,0-9.905,18.348l.008,0a60.1,60.1,0,0,0-2.476,17.113c0,2.382.14,23.22.411,40.134a22.239,22.239,0,0,0,22.241,21.878h0a22.248,22.248,0,0,0,21.353-16.01A22.158,22.158,0,0,1,600.409,541.182Z",
    transform: "translate(-319.671 -261.145)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M126.54,565.528h7.837l3.729-30.231H126.538Z",
    transform: "translate(-45.642 -193.082)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M0,0H24.633V9.517H9.517A9.517,9.517,0,0,1,0,0H0Z",
    transform: "translate(103.849 379.724) rotate(179.997)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M82.54,565.528h7.837L94.106,535.3H82.538Z",
    transform: "translate(-29.772 -193.082)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M0,0H24.633V9.517H9.517A9.517,9.517,0,0,1,0,0H0Z",
    transform: "translate(75.72 379.723) rotate(179.997)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M265,661.233l-7.656-.4a2.988,2.988,0,0,1-2.825-3.175l9.15-101.307,42.137,11.37,4.06-1.108-12.7,89.684a3,3,0,0,1-2.786,2.522l-8.253.385a2.988,2.988,0,0,1-3.153-3.066l1.5-53.827a1,1,0,0,0-1.971-.23l-14.421,56.778a2.97,2.97,0,0,1-2.921,2.382C265.108,661.238,265.054,661.236,265,661.233Z",
    transform: "translate(-205.383 -298.085)"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    className: "h",
    cx: 15.702,
    cy: 15.702,
    r: 15.702,
    transform: "translate(66.603 143.969)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M265.5,460.251l1.726,37.25.624,13.552a2.968,2.968,0,0,0,1.965,2.669L310.3,528.39a2.862,2.862,0,0,0,1.023.179,2.968,2.968,0,0,0,2.981-3.061l-1.66-66.978a23.61,23.61,0,0,0-19.654-22.808c-.392-.06-.79-.12-1.189-.173a23.174,23.174,0,0,0-18.645,6.036,23.8,23.8,0,0,0-7.663,18.665Z",
    transform: "translate(-209.334 -254.449)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M356.171,553.037a6.434,6.434,0,0,1-3.432-9.734l-13.731-18.258,11.849-.733,11.223,17.451a6.464,6.464,0,0,1-5.908,11.275Z",
    transform: "translate(-235.86 -286.529)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M337.814,513.9a2.97,2.97,0,0,1-1.624-1.61L315.5,463a7.968,7.968,0,1,1,14.694-6.167l20.687,49.287a2.991,2.991,0,0,1-1.6,3.911l-9.184,3.854a2.967,2.967,0,0,1-2.287.011Z",
    transform: "translate(-227.157 -260.427)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M298.308,523.722l19.869-38.044a3.119,3.119,0,0,1,4.2-1.319l28.84,15.062a3.119,3.119,0,0,1,1.319,4.2l-19.869,38.044a3.119,3.119,0,0,1-4.2,1.319l-28.84-15.062A3.119,3.119,0,0,1,298.308,523.722Z",
    transform: "translate(-221.052 -271.991)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M302.994,510.209a6.434,6.434,0,0,0-9.92-2.851l-19.037-12.629L274,506.6l18.083,10.172a6.464,6.464,0,0,0,10.907-6.564Z",
    transform: "translate(-212.413 -275.859)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M268.7,494.6l-15.558-12.324a10.972,10.972,0,0,1-5-17.347l14.127-18.514a6.454,6.454,0,0,1,10.951,6.575L262.042,471.27l16.426,7.791a2.988,2.988,0,0,1,1.245,4.3l-6.631,10.494a2.993,2.993,0,0,1-2.025,1.35l-.049.008A3,3,0,0,1,268.7,494.6Z",
    transform: "translate(-202.19 -257.577)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M283.49,400.163a1.365,1.365,0,0,1,1.187-1.8,3.152,3.152,0,0,1,2.222,1.1,8.845,8.845,0,0,0,1.963,1.686,1.689,1.689,0,0,0,2.223-.4,3.092,3.092,0,0,0-.118-2.4,23.593,23.593,0,0,1-1.042-6.246,11,11,0,0,1,1.573-6.679c1.69-2.381,4.713-3.285,7.573-3.22s5.674.948,8.507,1.507c.978.193,2.128.291,2.782-.467.7-.806.44-2.111.144-3.2-.768-2.824-1.582-5.744-3.366-8.025a12.082,12.082,0,0,0-7.71-4.341,18.5,18.5,0,0,0-8.606.977,23.077,23.077,0,0,0-11.3,7.875,18.69,18.69,0,0,0-3.566,13.809,17.048,17.048,0,0,0,6.32,10.775Z",
    transform: "translate(-213.05 -229.979)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M585.955,709.363a29.4,29.4,0,0,1-10.913-45.7,29.406,29.406,0,1,0,40,42.49A29.388,29.388,0,0,1,585.955,709.363Z",
    transform: "translate(-316.645 -336.792)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIsItForMe);
export default __webpack_public_path__ + "static/media/isItForMe.191f652a1dde6ce7156169e7a20f26b0.svg";
export { ForwardRef as ReactComponent };